import { LOSPluginItem } from "./LOSPluginItem";

export default LOSPluginItem;
